import { combineReducers } from '@reduxjs/toolkit';
import { showcaseRootReducer } from './showcase/slices';
import { resourceRootReducer } from './resource/slices';
import { rewardRootReducer } from './reward/slices';
import { dashboardRootReducer } from './dashboard/slices';
import { journalRootReducer } from './journal/slices';
import { analysisRootReducer } from './analysis/slices';
import { eventRootReducer } from './event/slices';
import { rankRootReducer } from './rank/slices';
import { postRootReducer } from './post/slices';
import { billingRootReducer } from './billing/slices';

export const rootReducer = combineReducers({
    dashboard: dashboardRootReducer,
    resource: resourceRootReducer,
    reward: rewardRootReducer,
    journal: journalRootReducer,
    analysis: analysisRootReducer,
    showcase: showcaseRootReducer,
    event: eventRootReducer,
    rank: rankRootReducer,
    post: postRootReducer,
    billing: billingRootReducer,
});
